const $inject = [];

const lbTripOptionsHotelFormItem = {
  controller: 'lbTripOptionsHotelFormItemCtrl as vm',
  template: require('./lbTripOptionsHotelFormItem.html'),
  bindings: {
    search: '<',
    isLast: '<',
    index: '<'
  }
};

lbTripOptionsHotelFormItem.$inject = $inject;

export default lbTripOptionsHotelFormItem;




// WEBPACK FOOTER //
// ./src/components/lbTripOptionsModal/lbTripOptionsHotelFormItem.js